import { Route } from '@angular/router';
import { AdminLayoutComponent } from '../features/admin/_ui/admin-layout/admin-layout.component';

const routes: Array<Route> = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: 'user',
        loadChildren: () =>
          import('../features/admin/admin-user/admin-user.routes').then(
            (module) => module.adminUserRoutes,
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import('../features/admin/admin-user/admin-user.component').then(
            (module) => module.AdminUserComponent,
          ),
      },
    ],
  },
];

export default routes;
